<template>
  <div class="puzzle-box">
    <div class="puzzle" v-if="twoRowImg.length==0&&info.type!=='container-onePlusN'">
      <div class="puzzle-item" v-for="(puzzleItem,idx) in info.items" :key="idx">
        <p class="title" v-text="puzzleItem.title" />
        <p class="sub-title">{{puzzleItem.subTitle}}</p>
        <div class="img-box">
          <div class="img" v-for="(imgItem,imgIdx) in puzzleItem.imgs" :key="imgIdx">
            <img :src="imgItem" alt />
          </div>
        </div>
      </div>
    </div>
    <template v-if="twoRowImg.length!==0&&info.type!=='container-onePlusN'">
      <div class="puzzle">
        <div class="puzzle-item" v-for="(puzzleItem,idx) in twoRowImg[0]" :key="idx">
          <p class="title" v-text="puzzleItem.title" />
          <p class="sub-title">{{puzzleItem.subTitle}}</p>
          <div class="img-box">
            <div class="img" v-for="(imgItem,imgIdx) in puzzleItem.imgs" :key="imgIdx">
              <img :src="imgItem" alt />
            </div>
          </div>
        </div>
      </div>
      <div class="puzzle">
        <div class="puzzle-item" v-for="(puzzleItem,idx) in twoRowImg[1]" :key="idx">
          <p class="title" v-text="puzzleItem.title" />
          <p class="sub-title">{{puzzleItem.subTitle}}</p>
          <div class="img-box">
            <div class="img" v-for="(imgItem,imgIdx) in puzzleItem.imgs" :key="imgIdx">
              <img :src="imgItem" alt />
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="info.type=='container-onePlusN'">
      <div class="onePlusN">
        <div class="col left">
          <div class="box">
            <p class="title">{{info.items[0].title}}</p>
            <p class="sub-title">{{info.items[0].subTitle}}</p>
            <div class="left-img-box">
              <img :src="info.items[0].imgs[0]" alt />
            </div>
            <p class="buynow">{{info.items[0].buyNow}}</p>
          </div>
        </div>
        <div class="col right">
          <div class="row" v-for="(item,idx) in onePlusRow" :key="idx">
            <p class="title">{{item.title}}</p>
            <p class="sub-title">{{item.subTitle}}</p>
            <div class="img-box">
              <div class="img" v-for="(img,imgIdx) in item.imgs" :key="imgIdx">
                <img :src="img" alt />
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <mask-btn-group
      @moveUp="$emit('moveUp',idx)"
      @moveDown="$emit('moveDown',idx)"
      @edit="$emit('edit',idx)"
      @del="$emit('del',idx)"
      :info="info"
      :idx="idx"
      :hasRecommend="hasRecommend"
      :moduleLength="moduleLength"
    ></mask-btn-group>
  </div>
</template>

<script>
import maskBtnGroup from './maskBtnGroup';

export default {
  name: 'puzzle',
  props: {
    idx: [String, Number],
    info: Object,
    moduleLength: [String, Number],
    hasRecommend:{
      type:Boolean,
      default:false,
    },
  },
  components: {
    maskBtnGroup,
  },
  computed: {
    twoRowImg: (vm) => {
      let items = [];
      if (vm.info.name == '拼图(两行两列)') {
        items[0] = [vm.info.items[0], vm.info.items[1]];
        items[1] = [vm.info.items[2], vm.info.items[3]];
      }
      return items;
    },
    onePlusRow: (vm) => {
      if (vm.info.type == 'container-onePlusN') {
        return [vm.info.items[1], vm.info.items[2]];
      } else {
        return [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.puzzle-box {
  margin-top: 10px;
  margin-bottom: 10px;
  width: 100%;
  position: relative;
}
.puzzle {
  position: relative;
  width: calc(100%-30px);
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 32px 22px -20px $light-gray, 0 2px 9px 0 $light-gray;
  margin-left: 15px;
  margin-right: 15px;
  .puzzle-item {
    border: solid 1px #fafafa;
    min-width: 30%;
    flex: 1;
    padding: 8px;
    background: #fff;
  }
}
.img-box {
  display: flex;
  flex-direction: row;
  margin-top: 4px;
  .img {
    flex: 1;
    &:nth-child(2) {
      margin: 0 5px;
    }
  }
  img {
    display: block;
    width: 100%;
    height: 52px;
  }
}
.title {
  font-size: 14px;
  line-height: 20px;
  height: 20px;
  color: #ff6766;
}
.sub-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  line-height: 16px;
  height: 14px;
  color: $gray;
  -webkit-line-clamp: 1;
}
.onePlusN {
  box-shadow: 0 32px 22px -20px $light-gray, 0 2px 9px 0 $light-gray;
  display: flex;
  flex-direction: row;
  margin: 0px 15px;
  .col {
    flex: 1;
    background: #fff;
    border: solid 1px #fafafa;
  }
  .left {
    .left-img-box {
      text-align: center;
      img {
        height: 100px;
        margin-top: 10px;
      }
    }
    .box {
      padding: 8px;
    }
    .buynow {
      margin-top: 8px;
      font-size: 12px;
      color: rgba(176, 190, 197, 1);
      line-height: 14px;
      text-align: center;
    }
  }
  .right {
    .row {
      padding: 8px;
      box-sizing: content-box;
      border: solid 1px #fafafa;
    }
  }
}
</style>